function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 9,
  r: 8,
  fill: "#636363"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M7.44 11.34C7.44 10.8173 7.50067 10.388 7.622 10.052C7.74333 9.716 7.89733 9.436 8.084 9.212C8.27067 8.97867 8.47133 8.78267 8.686 8.624C8.90067 8.46533 9.10133 8.302 9.288 8.134C9.47467 7.966 9.62867 7.77467 9.75 7.56C9.87133 7.34533 9.932 7.06533 9.932 6.72C9.932 6.216 9.75933 5.81 9.414 5.502C9.078 5.18467 8.58333 5.026 7.93 5.026C7.314 5.026 6.83333 5.18933 6.488 5.516C6.152 5.84267 5.96533 6.29067 5.928 6.86H4.92C4.95733 6.01067 5.23267 5.33867 5.746 4.844C6.26867 4.34933 6.99667 4.102 7.93 4.102C8.41533 4.102 8.84467 4.16733 9.218 4.298C9.59133 4.41933 9.904 4.59667 10.156 4.83C10.4173 5.06333 10.6133 5.33867 10.744 5.656C10.8747 5.97333 10.94 6.328 10.94 6.72C10.94 7.14933 10.8747 7.504 10.744 7.784C10.6227 8.05467 10.4687 8.288 10.282 8.484C10.0953 8.68 9.89467 8.85733 9.68 9.016C9.46533 9.17467 9.26467 9.35667 9.078 9.562C8.89133 9.758 8.73267 9.996 8.602 10.276C8.48067 10.556 8.42 10.9107 8.42 11.34H7.44ZM7.93 14.098C7.706 14.098 7.51933 14.0233 7.37 13.874C7.23 13.7247 7.16 13.5427 7.16 13.328C7.16 13.1133 7.23 12.9313 7.37 12.782C7.51933 12.6327 7.706 12.558 7.93 12.558C8.154 12.558 8.336 12.6327 8.476 12.782C8.62533 12.9313 8.7 13.1133 8.7 13.328C8.7 13.5427 8.62533 13.7247 8.476 13.874C8.336 14.0233 8.154 14.098 7.93 14.098Z",
  fill: "white"
});

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.c25e426f.svg";
export { ForwardRef as ReactComponent };